<template>
  <div>
    <CVUploader :currentWorker="userData" title="Upload your CV" showPreview />
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import CVUploader from "@/components/workers/CVUploader";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { createNamespacedHelpers } from "vuex";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  components: {
    CVUploader,
    PrimaryButton
  },
  created() {
    this.emitProgressValue(100);
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    })
  },
  methods: {
    emitProgressValue(value) {
      this.$emit("onStepChanged", {
        progressValue: value
      });
    },
    async nextStep() {
      this.emitProgressValue(101);
      this.$emit("close");
    },
    stepBack() {
      this.emitProgressValue(0);
    }
  }
};
</script>

<style lang="scss" scoped></style>
